import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { StethoscopeIcon, SearchIcon, PlusIcon } from 'lucide-react';
import { DoctorList } from '../components/doctor/DoctorList';
import { DoctorProfile } from '../components/doctor/DoctorProfile';
import { DoctorCalendar } from '../components/doctor/DoctorCalendar';
import { ConsultationWorkflow } from '../components/doctor/ConsultationWorkflow';
import { PerformanceDashboard } from '../components/doctor/PerformanceDashboard';
export function DoctorPortal() {
  const [selectedDoctorId, setSelectedDoctorId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeView, setActiveView] = useState<'profile' | 'calendar' | 'consultations' | 'performance'>('profile');
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-1821">
      <Navigation data-id="element-1822" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1823">
        <div className="flex items-center justify-between mb-6" data-id="element-1824">
          <div className="flex items-center space-x-3" data-id="element-1825">
            <StethoscopeIcon className="w-8 h-8 text-purple-600" data-id="element-1826" />
            <div data-id="element-1827">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-1828">
                Doctor Portal
              </h1>
              <p className="text-gray-600" data-id="element-1829">
                Comprehensive doctor management and consultation workflows
              </p>
            </div>
          </div>
          <button className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-1830">
            <PlusIcon className="w-5 h-5" data-id="element-1831" />
            <span data-id="element-1832">Add New Doctor</span>
          </button>
        </div>
        {/* Search Bar */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" data-id="element-1833">
          <div className="relative" data-id="element-1834">
            <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1835" />
            <input type="text" placeholder="Search doctors by name, specialization, or location..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent" data-id="element-1836" />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1837">
          {/* Doctor List */}
          <div className="lg:col-span-1" data-id="element-1838">
            <DoctorList searchTerm={searchTerm} selectedDoctorId={selectedDoctorId} onSelectDoctor={setSelectedDoctorId} data-id="element-1839" />
          </div>
          {/* Doctor Details */}
          <div className="lg:col-span-2" data-id="element-1840">
            {selectedDoctorId ? <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-1841">
                {/* Tabs */}
                <div className="border-b border-gray-200" data-id="element-1842">
                  <div className="flex overflow-x-auto" data-id="element-1843">
                    <button onClick={() => setActiveView('profile')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'profile' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1844">
                      Profile & Details
                    </button>
                    <button onClick={() => setActiveView('calendar')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'calendar' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1845">
                      Calendar Management
                    </button>
                    <button onClick={() => setActiveView('consultations')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'consultations' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1846">
                      Consultations
                    </button>
                    <button onClick={() => setActiveView('performance')} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeView === 'performance' ? 'text-purple-600 border-b-2 border-purple-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1847">
                      Performance
                    </button>
                  </div>
                </div>
                {/* Tab Content */}
                <div className="p-6" data-id="element-1848">
                  {activeView === 'profile' && <DoctorProfile doctorId={selectedDoctorId} data-id="element-1849" />}
                  {activeView === 'calendar' && <DoctorCalendar doctorId={selectedDoctorId} data-id="element-1850" />}
                  {activeView === 'consultations' && <ConsultationWorkflow doctorId={selectedDoctorId} data-id="element-1851" />}
                  {activeView === 'performance' && <PerformanceDashboard doctorId={selectedDoctorId} data-id="element-1852" />}
                </div>
              </div> : <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12 text-center" data-id="element-1853">
                <StethoscopeIcon className="w-16 h-16 text-gray-300 mx-auto mb-4" data-id="element-1854" />
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1855">
                  No Doctor Selected
                </h3>
                <p className="text-gray-500" data-id="element-1856">
                  Select a doctor from the list to view their profile and manage
                  consultations
                </p>
              </div>}
          </div>
        </div>
      </div>
    </div>;
}